// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

import { Notification, PaginationListResponse } from '../../../types/Model';

export interface GetNotificationsRequestPayload {
  page: number;
  limit: number;
}
export interface GetNotificationsSuccessPayload extends PaginationListResponse<Notification> {
  unread: number;
}

export interface GetNotificationsFailPayload {
  error: Error;
}

export const getNotificationsActions = createAsyncAction(
  'elearning/GET_NOTIFICATIONS',
  'elearning/GET_NOTIFICATIONS_SUCCESS',
  'elearning/GET_NOTIFICATIONS_FAIL'
)<GetNotificationsRequestPayload, GetNotificationsSuccessPayload, GetNotificationsFailPayload>();
